import { render, staticRenderFns } from "./upload-material.html?vue&type=template&id=b1d9f950&scoped=true&external"
import script from "./upload-material.js?vue&type=script&lang=js&external"
export * from "./upload-material.js?vue&type=script&lang=js&external"
import style0 from "./upload-material.scss?vue&type=style&index=0&id=b1d9f950&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d9f950",
  null
  
)

export default component.exports